import React from 'react'

export function SpaceStation({ className = '' }) {
  return (
    <svg
      viewBox="0 0 1200 600"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <linearGradient id="spaceBg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#020111" />
          <stop offset="100%" stopColor="#20124d" />
        </linearGradient>
        <linearGradient id="stationMetal" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#e0eaf5" />
          <stop offset="50%" stopColor="#8b9bb4" />
          <stop offset="100%" stopColor="#4a5568" />
        </linearGradient>
        <radialGradient id="earthGrad" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#4facfe" />
          <stop offset="70%" stopColor="#00f2fe" />
          <stop offset="100%" stopColor="#000000" />
        </radialGradient>
        <filter id="energyGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Background */}
      <rect width="1200" height="600" fill="url(#spaceBg)" />

      {/* Stars */}
      <g fill="#ffffff">
        <circle cx="100" cy="100" r="2" opacity="0.8" />
        <circle cx="250" cy="50" r="1.5" opacity="0.6" />
        <circle cx="400" cy="200" r="2.5" opacity="0.7" />
        <circle cx="600" cy="80" r="1" opacity="0.9" />
        <circle cx="800" cy="150" r="2" opacity="0.5" />
        <circle cx="1000" cy="60" r="1.5" opacity="0.8" />
        <circle cx="1150" cy="250" r="2" opacity="0.6" />
        <circle cx="50" cy="350" r="1.5" opacity="0.7" />
        <circle cx="1100" cy="450" r="2" opacity="0.5" />
      </g>

      {/* Distant Earth */}
      <circle cx="900" cy="400" r="250" fill="url(#earthGrad)" opacity="0.6" />

      {/* Main Platform */}
      <g transform="translate(150, 450)">
        <path d="M100 0 L800 0 L900 50 L800 100 L100 100 L0 50 Z" fill="url(#stationMetal)" />
        <path d="M150 20 L750 20 M150 80 L750 80" stroke="#2d3748" strokeWidth="2" />
        <rect x="400" y="40" width="100" height="20" rx="10" fill="#00ffff" filter="url(#energyGlow)" />
        <path d="M0 50 L100 50 M800 50 L900 50" stroke="#00ffff" strokeWidth="4" filter="url(#energyGlow)" />
      </g>

      {/* Left Floating Platform */}
      <g transform="translate(200, 280)">
        <path d="M20 0 L230 0 L250 15 L230 30 L20 30 L0 15 Z" fill="url(#stationMetal)" />
        <rect x="100" y="12" width="50" height="6" rx="3" fill="#00ffff" filter="url(#energyGlow)" />
      </g>

      {/* Right Floating Platform */}
      <g transform="translate(750, 280)">
        <path d="M20 0 L230 0 L250 15 L230 30 L20 30 L0 15 Z" fill="url(#stationMetal)" />
        <rect x="100" y="12" width="50" height="6" rx="3" fill="#00ffff" filter="url(#energyGlow)" />
      </g>

      {/* Top Center Floating Platform */}
      <g transform="translate(475, 120)">
        <path d="M20 0 L230 0 L250 15 L230 30 L20 30 L0 15 Z" fill="url(#stationMetal)" />
        <rect x="100" y="12" width="50" height="6" rx="3" fill="#00ffff" filter="url(#energyGlow)" />
      </g>
    </svg>
  )
}
